import { render, staticRenderFns } from "./selectType.vue?vue&type=template&id=08bf5df6&"
import script from "./selectType.vue?vue&type=script&lang=js&"
export * from "./selectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports